<script lang="ts">
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let maestros = []

</script>
<div>
    <table class="naui-table" style="min-width: 300px">
        <thead>
        <tr>
            <th colspan="3">
                <div>
                    Maestro
                </div>
            </th>
        </tr>
        </thead>
        <tbody>
        {#each maestros as m}
            <tr>
                <td>
                    <div>
                        {m.name}
                    </div>
                </td>
                <td>
                    {#if m.template}
                        <div>
                            <NauiButton href="{m.template}"
                                        caption="Template"
                                        icon="download"/>
                        </div>
                    {/if}
                </td>
                <td>
                    <div class="box">
                        <NauiButton href={m.route}
                                    icon="plus-circle"
                                    iconFamily="fal"
                                    color="accent"/>
                    </div>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
</div>